import * as React from "react";

import {
  Tabs as PrimitiveTabs,
  TabsContent as PrimitiveTabsContent,
  TabsList as PrimitiveTabsList,
  TabsTrigger as PrimitiveTabsTrigger,
  tabsListVariants,
} from "../../primitive/tabs";
import { cn } from "../../lib/cn";

export type TabsProps = React.ComponentProps<typeof PrimitiveTabs>;
export type TabsListProps = React.ComponentProps<typeof PrimitiveTabsList>;
export type TabsTriggerProps = React.ComponentProps<
  typeof PrimitiveTabsTrigger
> & {
  size?: "default" | "icon";
};
export type TabsContentProps = React.ComponentProps<
  typeof PrimitiveTabsContent
>;

export const Tabs = PrimitiveTabs;
export const TabsList = PrimitiveTabsList;
export function TabsTrigger({
  className,
  size = "default",
  ...props
}: TabsTriggerProps) {
  return (
    <PrimitiveTabsTrigger
      className={cn(size === "icon" && "size-8 flex-none p-0", className)}
      {...props}
    />
  );
}
export const TabsContent = PrimitiveTabsContent;
export { tabsListVariants };
